import { render, staticRenderFns } from "./WatsonInfo.vue?vue&type=template&id=f9683e9e&"
import script from "./WatsonInfo.vue?vue&type=script&lang=js&"
export * from "./WatsonInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports